import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Stack } from 'ui';
import useJourneyData from '~/hooks/useJourneyData';
import { useJourneyEditErrorMessage } from '~/hooks/useJourneyEditErrorMessage';
import { useCurrentJourney, useJourneyEditErrors } from '~/stores/journeyStore';
import { isJourneyExpired } from '~/utils/dateHelpers/dateHelpers';
import { richLink } from '~/utils/richTextTags';
import { MessagePanel } from '../MessagePanel';
const contactLink = richLink({
  href: 'https://byway.travel/contact'
});
const JourneyMessaging = () => {
  const $ = _c(15);
  const t = useTranslations("journey");
  const tFeedback = useTranslations("content.feedback");
  const {
    pricingExceptionBannerText,
    expirationDateTime,
    source
  } = useCurrentJourney();
  const {
    urlPath,
    alertMessages
  } = useJourneyData();
  const isHighPriceBannerEnabled = process.env.NEXT_PUBLIC_HIGH_PRICE_MESSAGING_ENABLED === "true";
  const isBlueprintTemplate = urlPath === "journey-template";
  const isBlueprintJourney = source.creationSource === "FROM_TEMPLATE";
  const isBlueprint = isBlueprintJourney || isBlueprintTemplate;
  let t0;
  if ($[0] !== expirationDateTime || $[1] !== isBlueprint) {
    t0 = isJourneyExpired(expirationDateTime, isBlueprint);
    $[0] = expirationDateTime;
    $[1] = isBlueprint;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isExpired = t0;
  let t1;
  if ($[3] !== pricingExceptionBannerText) {
    t1 = isHighPriceBannerEnabled && pricingExceptionBannerText && <div className="w-full typography-body-2 md:typography-body-1"><MessagePanel status="info" dismissable={true} message={pricingExceptionBannerText && <div dangerouslySetInnerHTML={{
        __html: pricingExceptionBannerText
      }} />} /></div>;
    $[3] = pricingExceptionBannerText;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isExpired || $[6] !== t) {
    t2 = isExpired && <div className="w-full typography-body-2 md:typography-body-1"><MessagePanel status="error" dismissable={true} message={<span>{t.rich("expired_notice", {
          link: contactLink
        })}</span>} /></div>;
    $[5] = isExpired;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== alertMessages || $[9] !== tFeedback) {
    t3 = alertMessages?.includes("PRICE_CHANGE") && <div className="w-full typography-body-2 md:typography-body-1"><MessagePanel status="info" dismissable={true} message={<span>{tFeedback.rich("price_updated_notice", {
          link: contactLink
        })}</span>} /></div>;
    $[8] = alertMessages;
    $[9] = tFeedback;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <Stack className="px-2 pb-3 md:px-0 md:flex" spacing={2}>{t1}{t2}{t3}</Stack>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
function JourneyMessagingMobile() {
  const $ = _c(7);
  const journeyEditErrors = useJourneyEditErrors();
  const editErrorMessage = useJourneyEditErrorMessage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <hr className="pt-4 mx-4 border-neutral-200" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== editErrorMessage || $[2] !== journeyEditErrors) {
    t1 = !journeyEditErrors.includes("UNKNOWN_FAILURE") && journeyEditErrors.length > 0 && <MessagePanel status="error" dismissable={true} message={journeyEditErrors.length === 1 ? <p>{editErrorMessage(journeyEditErrors[0])}</p> : <ul className="pl-4 list-disc">{journeyEditErrors.map((errorMessage, i) => <li key={`journeyTemplateError-${i}-${errorMessage}`}>{editErrorMessage(errorMessage)}</li>)}</ul>} />;
    $[1] = editErrorMessage;
    $[2] = journeyEditErrors;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <JourneyMessaging />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <div className="pt-3 md:hidden">{t0}{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function JourneyMessagingDesktop() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden md:block"><JourneyMessaging /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { JourneyMessagingMobile, JourneyMessagingDesktop };